var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container, style: _vm.containerStyle }, [
    _c("div", {
      class: _vm.$style.scrim,
      style: _vm.scrimStyle,
      attrs: { "data-testid": "nsDrawerScrim" },
      on: {
        click: function($event) {
          return _vm.$emit("close")
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "content",
        class: _vm.$style.content,
        style: _vm.contentStyle,
        on: { touchmove: _vm.handleTouchMove, touchend: _vm.handleTouchEnd }
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }